import { Delete as DeleteIcon, Edit as EditIcon } from '@mui/icons-material';
import { Box, Grid } from '@mui/material';
import PropTypes from 'prop-types';

import { TypographyApp } from '../custom/CustomComponents';
import { ButtonHeaderApp } from '../custom/DedicatedComponents';

/**
 * Panel informativo para jugadores creados manualmente.
 * Muestra un aviso explicativo y los botones de Editar y Eliminar.
 */
const InfoJugadorManual = ({ onEdit, onDelete }) => (
  <Grid item xs={12} md={11}>
    <Box
      sx={{
        textAlign: 'center',
        py: 6,
        px: 2,
        backgroundColor: 'rgba(0,0,0,0.02)',
        borderRadius: 2,
        border: '1px dashed rgba(0,0,0,0.1)',
      }}
    >
      <TypographyApp sx={{ fontSize: '1.2rem', fontWeight: 'bold', color: 'text.secondary' }}>
        Jugador creado manualmente
      </TypographyApp>
      <TypographyApp sx={{ mt: 1, color: 'text.secondary' }}>
        Este jugador ha sido creado manualmente y por tanto no dispone de historial de equipos ni de registros de
        partidos oficiales.
      </TypographyApp>
      <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1, mt: 3 }}>
        <ButtonHeaderApp
          onClick={onEdit}
          endIcon={<EditIcon />}
          sx={{ border: '1px solid', backgroundColor: 'primary.light' }}
        >
          <TypographyApp fontSize={13} sx={{ color: 'primary.contrastText' }}>
            Editar jugador
          </TypographyApp>
        </ButtonHeaderApp>
        <ButtonHeaderApp
          onClick={onDelete}
          endIcon={<DeleteIcon />}
          sx={{
            border: '1px solid rgba(252, 0, 0, 0.4)',
            backgroundColor: 'error.light',
            color: 'error.contrastText',
          }}
        >
          <TypographyApp fontSize={13} sx={{ color: 'error.contrastText' }}>
            Eliminar jugador
          </TypographyApp>
        </ButtonHeaderApp>
      </Box>
    </Box>
  </Grid>
);

InfoJugadorManual.propTypes = {
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default InfoJugadorManual;
